// intro-app/account/recovery.js

(function () {
    'use strict';
    var controllerId = 'recovery';
    angular.module('intro-app').controller(controllerId, ['datacontext', '$translate', recoveryFn]);

    function recoveryFn(datacontext, $translate) {
        var vm = this;
        vm.error = null;
        vm.success = false;
        vm.item = {};
        vm.recovery = recovery;

        vm.lingua = $translate.use();

        function recovery() {
            vm.error = null;
            vm.success = false;

            return datacontext.account_recovery(vm.item).then(function (response) {
                if (response.status == 200) {
                    vm.success = true;
                    vm.email = vm.item.Email;
                    vm.item = {};
                }
                else {
                    vm.error = response.data;
                }
            });
        }
    }
})();